import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import CalculatorOptionHandler from './handlers/CalculatorOptionHandler';
import DisplayTitleOptionHandler from './handlers/DisplayTitleOptionHandler';
import DoNothingOptionHandler from './handlers/DoNothingOptionHandler';
import IOptionHandler from './handlers/IOptionHandler';
import FlagItemOptionHandler from './handlers/FlagItemOptionHandler';
import NotepadOptionHandler from './handlers/NotepadOptionHandler';
import PauseOptionHandler from './handlers/PauseOptionHandler';
import ProgressBarOptionHandler from './handlers/ProgressBarOptionHandler';
import FocusModeOptionHandler from './handlers/FocusModeOptionHandler';
import ProctorReleaseOptionHandler from './handlers/ProctorReleaseOptionHandler';
import BasicOptionHandler from './handlers/BasicOptionHandler';
import DisplayNameHandler from './handlers/DisplayNameHandler';
import TestController from '@/controllers/TestController';
import TimerOptionHandler from './handlers/TimerOptionHandler';
import RedirectUrlHandler from './handlers/RedirectUrlHandler';

class DeliveryOptionHandlerFactory {
  static createDeliveryOptionHandler(key: string, testController: TestController): IOptionHandler {
    switch (key.toLowerCase()) {
      case DeliveryOptionConstants.SHOW_FORM_TITLE: {
        return new DisplayTitleOptionHandler();
      }
      case DeliveryOptionConstants.NOTEPAD: {
        return new NotepadOptionHandler();
      }
      case DeliveryOptionConstants.CALCULATOR: {
        return new CalculatorOptionHandler();
      }
      case DeliveryOptionConstants.SHOW_PROGRESS_BAR: {
        return new ProgressBarOptionHandler();
      }
      case DeliveryOptionConstants.PAUSE_BUTTON: {
        return new PauseOptionHandler();
      }
      case DeliveryOptionConstants.FLAG_ITEM: {
        return new FlagItemOptionHandler();
      }
      case DeliveryOptionConstants.FOCUS_MODE: {
        return new FocusModeOptionHandler();
      }
      case DeliveryOptionConstants.PROCTOR_RELEASE: {
        return new ProctorReleaseOptionHandler();
      }
      case DeliveryOptionConstants.STUDENT_NAME: {
        return new DisplayNameHandler(testController);
      }
      case DeliveryOptionConstants.TIMER_OPTION: {
        return new TimerOptionHandler();
      }
      case DeliveryOptionConstants.SHOW_REDIRECT_URL: {
        return new RedirectUrlHandler();
      }
      case DeliveryOptionConstants.QUESTION_NUMBER:
      case DeliveryOptionConstants.ITEM_PROGRESS:
      case DeliveryOptionConstants.REVIEW_SCREEN:
      case DeliveryOptionConstants.FINAL_REVIEW_SCREEN:
      case DeliveryOptionConstants.WARN_ON_CHANGE:
      case DeliveryOptionConstants.BLOCK_RETURN_TO_SECTION:
      case DeliveryOptionConstants.CHOICE_MASKING:
      case DeliveryOptionConstants.LINE_READER:
      case DeliveryOptionConstants.COLOR_SCHEME:
      case DeliveryOptionConstants.ZOOM:
      case DeliveryOptionConstants.FONT_SIZE:
      case DeliveryOptionConstants.DICTIONARY:
      case DeliveryOptionConstants.LOGOUT_SECTION:
      case DeliveryOptionConstants.EXIT_BUTTON:
      case DeliveryOptionConstants.HIGHLIGHTER: {
        return new BasicOptionHandler(key);
      }

      default: {
        return new DoNothingOptionHandler();
      }
    }
  }
}

export default DeliveryOptionHandlerFactory;
